import { useMutation, useQuery } from '@tanstack/react-query'
import { addNewOnboardingScreen, updateOnboardingScreen, updateStatusOnboardingScreen, listOnboardingScreens, deleteOnboardingScreen } from '../api/onboarding'

export const useAddOnboarding = () => {
  return useMutation({
    mutationFn: addNewOnboardingScreen
  })
}

export const useUpdateOnboarding = () => {
  return useMutation({
    mutationFn: updateOnboardingScreen
  })
}

export const useUpdateStatusOnboarding = () => {
  return useMutation({
    mutationFn: updateStatusOnboardingScreen
  })
}

export const useDeleteOnboarding = () => {
  return useMutation({
    mutationFn: deleteOnboardingScreen
  })
}

export const useListOnboardingQuery = (queryParams = '') => {
  return useQuery({
    queryKey: ['onboarding_screens', queryParams],
    queryFn: () => listOnboardingScreens(queryParams),
  });
};